import { render, staticRenderFns } from "./TestContinentList.vue?vue&type=template&id=68fc95c2"
import script from "./TestContinentList.vue?vue&type=script&lang=js"
export * from "./TestContinentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68fc95c2')) {
      api.createRecord('68fc95c2', component.options)
    } else {
      api.reload('68fc95c2', component.options)
    }
    module.hot.accept("./TestContinentList.vue?vue&type=template&id=68fc95c2", function () {
      api.rerender('68fc95c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/grid/TestContinentList.vue"
export default component.exports